import { useProductRefreshAlphaEnabled } from './useProductRefreshAlphaEnabled'
import { useProductRefreshGlobalBetaEnabled } from './useProductRefreshGlobalBetaEnabled'

/**
 * Controls visibility of `ProductRefreshPreviewToggle` (`app-layout-debug-switch`).
 * Alpha-only dev tool — hidden when the user is also in the global beta cohort.
 */
export function useShowProductRefreshToggle(): boolean {
  const isAlpha = useProductRefreshAlphaEnabled()
  const isGlobalBeta = useProductRefreshGlobalBetaEnabled()

  return isAlpha && !isGlobalBeta
}
